<template>
    <rkm-area
        no-margin-top
        title="Outros exames"
    >
        <rkm-row>
            <rkm-col cols="12">
                <rkm-list
                    :items="item.plano.solicitacoesExamesComuns"
                    hide-filters
                    hide-pagination
                >
                    <template v-slot="{item}">
                        <rkm-row>
                            <rkm-col>
                                <Item
                                    :get-value="() => `${formatCid(item.cid.codigo)} - ${item.cid.nome}`"
                                    label="CID 10"
                                />
                            </rkm-col>

                            <rkm-col>
                                <Item
                                    :get-value="() => `${formatCid(item.ciap.codigo)} - ${item.ciap.descricao}`"
                                    label="CIAP 2"
                                />
                            </rkm-col>

                            <rkm-col>
                                <Item
                                    :get-value="() => item.classificacaoRisco?.descricaoEncaminhamento"
                                    label="Classificação de risco"
                                />
                            </rkm-col>

                            <rkm-col>
                                <Item
                                    :get-value="() => item.justificativa"
                                    label="Justificativa do procedimento"
                                />
                            </rkm-col>

                            <rkm-col>
                                <Item
                                    :get-value="() => item.observacao"
                                    label="Observações"
                                />
                            </rkm-col>
                        </rkm-row>
                    </template>

                    <template v-slot:collapse="{item}">
                        <rkm-row class="p-2">
                            <rkm-col>
                                <rkm-table
                                    :fields="[{key: 'exame', label: 'Exame', sortable: true}]"
                                    :items="item.itens"
                                    hide-filters
                                    hide-pagination
                                >
                                    <template v-slot:cell(exame)="{item}">
                                        {{formatProcedimento(item.exame.codigo)}} - {{item.exame.nome}}
                                    </template>
                                </rkm-table>
                            </rkm-col>
                        </rkm-row>
                    </template>
                </rkm-list>
            </rkm-col>
        </rkm-row>
    </rkm-area>
</template>

<script>
// Components.
import Item from '@/components/ambulatorio/atendimento/components/historico/components/item/Index'

// Mixins.
import {formats} from '@/mixins'

export default {
    components: {Item},
    mixins: [formats],
    props: {
        item: {type: Object, required: true},
    },
}
</script>